'use strict';

/**
 *
 * @name: nownessApp.api
 *
 */

import ApiRun from './_api.run';
import BookmarkService from './bookmark.service';
import CategoryService from './category.service';
import CommentsService from './comments.service';
import ContactRequestService from './contact-request.service';
import LoveService from './love.service';
import MemberSocialFeedService from './member-social-feed.service';
import ModulesService from './modules.service';
import MastheadService from './masthead.service';
import SplashscreenAdService from './splashscreen-ad.service';
import NotificationsService from './notifications.service';
import nnHttpInterceptorFactory from './nn-http-interceptor.factory';
import PicksService from './picks.service';
import PlaylistFactory from './playlist.factory';
import PostService from './post.service';
import SearchService from './search.service';
import SeasonsService from './seasons.service';
import SeriesService from './series.service';
import SubscriptionsService from './subscriptions.service';
import TagService from './tag.service';
import UserService from './user.service';
import UtilityService from './utility.service';
import NewsletterService from './newsletter.service';

const ApiModule = angular
  .module('nownessApp.api', [])
  .run(ApiRun)
  .service('apiBookmarkService', BookmarkService)
  .service('apiCategoryService', CategoryService)
  .service('apiCommentsService', CommentsService)
  .service('apiContactRequestService', ContactRequestService)
  .service('apiLoveService', LoveService)
  .service('apiMemberSocialFeedService', MemberSocialFeedService)
  .service('apiMastheadService', MastheadService)
  .service('apiSplashscreenAdService', SplashscreenAdService)
  .service('apiModulesService', ModulesService)
  .service('apiNotificationsService', NotificationsService)
  .service('nnHttpInterceptor', nnHttpInterceptorFactory)
  .service('apiPicksService', PicksService)
  .factory('Playlist', PlaylistFactory)
  .service('apiPostService', PostService)
  .service('apiSearchService', SearchService)
  .service('apiSeasonsService', SeasonsService)
  .service('apiSeriesService', SeriesService)
  .service('apiSubscriptionsService', SubscriptionsService)
  .service('apiTagService', TagService)
  .service('apiUserService', UserService)
  .service('apiUtilityService', UtilityService)
  .service('apiNewsletterService', NewsletterService)

export default ApiModule.name;



// WEBPACK FOOTER //
// ./app/components/_api/_api.module.js